import { render, staticRenderFns } from "./CtrlFormulariosPage.vue?vue&type=template&id=28c3d7db"
import script from "./CtrlFormulariosPage.vue?vue&type=script&lang=js"
export * from "./CtrlFormulariosPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports